import React from 'react';
import { Row } from 'antd';
import { Formik, Form as FormikForm, FormikHelpers } from 'formik';
import Logo from 'assets/logo/logo_full.png';
import InputField from 'shared/components/InputField';
import COButton from 'shared/components/COButton';
import styles from './VerifyEmailForm.module.scss';
import { VerifyEmailFormEnums } from 'enums/VerifyEmailFormEnums';
import {
  Fields,
  initialValues,
  validationSchema,
} from './VerifyEmailFormConstants';
import AuthenticationService from 'services/AuthenticationService/authentication.service';
import { useNavigate } from 'react-router-dom';
import UserCompanyService from 'services/AuthenticationService/userCompany.service';

interface VerifyEmailProps {
  email: string;
  forgotPass?: boolean;
}

interface SignupFormDetails {
  name: string;
  position: string;
  phone: string;
  password: string;
}

interface VerifyEmailFormValues {
  password: string;
}

const VerifyEmailForm: React.FC<VerifyEmailProps> = ({
  email,
  forgotPass,
}: VerifyEmailProps) => {
  const navigate = useNavigate();
  const { verifyOTP, sendVerificationEmail } = AuthenticationService();
  const { registerUser } = UserCompanyService();
  const signupFormDetails = localStorage.getItem('signupUser');
  let parsedForm: SignupFormDetails | null = null;

  if (signupFormDetails) {
    parsedForm = JSON.parse(signupFormDetails) as SignupFormDetails;
  }

  const { name } = parsedForm || {};

  const handleApiSubmission = async (values: VerifyEmailFormValues) => {
    try {
      await verifyOTP(forgotPass, {
        email: email,
        otp: Number(values.password),
      });
      if (parsedForm) {
        await registerUser({ ...parsedForm, email, extension: '+1' });
      }
    } catch (error) {
      console.log('something went wrong!');
    }
  };

  const handleBackButton = () => {
    navigate(-1);
  };

  const handleResendOTP = async (
    setFieldValue: FormikHelpers<VerifyEmailFormValues>['setFieldValue']
  ) => {
    await sendVerificationEmail({ email: email?.toString(), name: name || '' });
    setFieldValue('password', '');
  };

  return (
    <div className={styles.formContainer}>
      <Row className={styles.logoContainer}>
        <img
          src={Logo}
          alt={VerifyEmailFormEnums.IMAGE_ALT}
          className={styles.logo}
        />
      </Row>
      <Row className={styles.headingContainer}>
        <div>
          <h1>{VerifyEmailFormEnums.HEADING}</h1>
        </div>
        <div>
          <h2>{VerifyEmailFormEnums.SUBHEADING}</h2>
        </div>
      </Row>
      <div className={styles.fieldsContainer}>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={values => handleApiSubmission(values)}>
          {formik => (
            <FormikForm>
              {Fields.map((field, index) => {
                return (
                  <div key={index} className={styles.fieldContainer}>
                    <InputField
                      name={field.name}
                      placeholderstring={field.placeholder}
                      maxLength={field.maxLength}
                      label={field.label}
                    />
                    {field.helper && (
                      <div className={styles.helpercontainer}>
                        <p>
                          {VerifyEmailFormEnums.HELPER_TEXT}{' '}
                          <span
                            className={styles.spanText}
                            onClick={() =>
                              handleResendOTP(formik.setFieldValue)
                            }>
                            {VerifyEmailFormEnums.HELPER_TEXT_SPAN}
                          </span>
                        </p>
                      </div>
                    )}
                  </div>
                );
              })}

              <div className={styles.buttonContainer}>
                <COButton
                  loading={formik.isSubmitting}
                  submit
                  disabled={!formik.isValid}>
                  {VerifyEmailFormEnums.BUTTON_LABEL_SUBMIT}
                </COButton>
                <COButton secondary onClick={handleBackButton}>
                  {VerifyEmailFormEnums.BUTTON_LABEL_BACK}
                </COButton>
              </div>
            </FormikForm>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default VerifyEmailForm;
